import { SvelteSubject } from "@common/store/reactive"
import type { LocationDescription } from "@common/models/interfaces"

export const currentLocation = new SvelteSubject<LocationDescription>({ lat: 0, lng: 0, title: "" })